// Default Roblox terrain palette. Heights are on a 0-255 grayscale scale,
// distributed evenly across all 22 colors as bands.
const ROBLOX_COLORS = [
  { name: "Water", color: "rgb(12, 84, 92)" },
  { name: "Basalt", color: "rgb(30, 30, 37)" },
  { name: "Mud", color: "rgb(58, 46, 36)" },
  { name: "Slate", color: "rgb(63, 127, 107)" },
  { name: "Glacier", color: "rgb(101, 176, 234)" },
  { name: "Ground", color: "rgb(102, 92, 59)" },
  { name: "Rock", color: "rgb(102, 108, 111)" },
  { name: "Grass", color: "rgb(106, 127, 63)" },
  { name: "Asphalt", color: "rgb(115, 123, 107)" },
  { name: "LeafyGrass", color: "rgb(115, 132, 74)" },
  { name: "Concrete", color: "rgb(127, 102, 63)" },
  { name: "Ice", color: "rgb(129, 194, 224)" },
  { name: "Cobblestone", color: "rgb(132, 123, 90)" },
  { name: "Sandstone", color: "rgb(137, 90, 71)" },
  { name: "Brick", color: "rgb(138, 86, 62)" },
  { name: "WoodPlanks", color: "rgb(139, 109, 79)" },
  { name: "Sand", color: "rgb(143, 126, 95)" },
  { name: "Pavement", color: "rgb(148, 148, 140)" },
  { name: "Snow", color: "rgb(195, 199, 218)" },
  { name: "Salt", color: "rgb(198, 189, 181)" },
  { name: "Limestone", color: "rgb(206, 173, 148)" },
  { name: "CrackedLava", color: "rgb(232, 156, 74)" },
];

export function rgbStringToHex(rgb) {
  const m = rgb.match(/\d+/g);
  if (!m) return "#000000";
  const [r, g, b] = m.map((x) => Number(x));
  return (
    "#" +
    [r, g, b]
      .map((v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0"))
      .join("")
  );
}

export function hexToRgb(hex) {
  const h = hex.replace("#", "");
  const full =
    h.length === 3
      ? h.split("").map((c) => c + c).join("")
      : h.padEnd(6, "0");
  return {
    r: parseInt(full.slice(0, 2), 16),
    g: parseInt(full.slice(2, 4), 16),
    b: parseInt(full.slice(4, 6), 16),
  };
}

export function buildDefaultLayers() {
  const total = ROBLOX_COLORS.length;
  const step = 255 / total;
  return ROBLOX_COLORS.map((c, i) => ({
    id: `layer_${Date.now()}_${i}_${Math.random().toString(36).slice(2, 6)}`,
    name: c.name,
    color: rgbStringToHex(c.color),
    min: Math.round(i * step),
    max: Math.round((i + 1) * step),
    solid: true,
  }));
}

export const ROBLOX_PRESET = {
  name: "Roblox Terrain",
  builtIn: true,
  createdAt: null,
};
